import { M as Modal } from "./modal-C2lX66I4.js";
import "./tua-bsl-uIxvG2ZV.js";
class AgeGate extends Modal {
  constructor() {
    super();
    this.confirmButton;
    this.cancelButton;
  }
  connectedCallback() {
    this.cacheAgeGateDomElements();
    this.setEventListeners();
    this.handleEntryAgeGate();
    super.connectedCallback();
  }
  cacheAgeGateDomElements() {
    this.confirmButton = this.querySelector(
      '[js-age-gate="confirmButton"]'
    );
    this.cancelButton = this.querySelector(
      '[js-age-gate="cancelButton"]'
    );
  }
  setEventListeners() {
    var _a, _b;
    (_a = this.confirmButton) == null ? void 0 : _a.addEventListener("click", () => this.handleConfirm());
    (_b = this.cancelButton) == null ? void 0 : _b.addEventListener("click", () => this.hideAgeGate());
  }
  handleEntryAgeGate() {
    if (this.isAgeApproved()) {
      return;
    }
    const entryAgeGateEnabled = this.getAttribute("settings-entry-gate-enabled") === "true";
    const entryAgeGateDelay = this.getAttribute("settings-entry-gate-delay") || 0;
    if (!entryAgeGateEnabled) {
      return;
    }
    setTimeout(() => {
      super.showModal();
    }, Number(entryAgeGateDelay));
  }
  handleConfirm() {
    document.dispatchEvent(new Event("ageGate:approved"));
    this.setLocalStorage();
    this.hideAgeGate();
  }
  showAgeGate() {
    if (this.isAgeApproved()) {
      return;
    }
    super.showModal();
  }
  hideAgeGate() {
    super.hideModal();
  }
  setLocalStorage() {
    localStorage.setItem("ageGateApproved", "true");
  }
  isAgeApproved() {
    const ageGateApproved = localStorage.getItem("ageGateApproved");
    if (ageGateApproved) {
      return true;
    }
    return false;
  }
}
customElements.define("uwp-age-gate", AgeGate);
